import { Routes } from "@angular/router";

export const sendInvitationListRoutes: Routes = [
  {
    path: "",
    title: "FRIENDS_OF_OMAN_MUSEUM.SEND_INVITATION",
    loadComponent: () => import("./pages/send-invitation-list/send-invitation-list.component").then((m) => m.SendInvitationListComponent),
  },
];
